import Vue from 'vue';
import Vuex from 'vuex';
import {MessageBox} from 'mint-ui';
import appConst from './store.const.js';
import appUtils from './store.utils.js';
import createPersistedState from 'vuex-persistedstate'; // state数据持久化
import {getUserIdentity} from 'src/components/api/interface-hhy';
import {BUSINESS_TYPE_TS} from 'src/components/api/interface-saas';
import {getLocalStorageItem, setLocalStorageItem} from 'src/components/api/utils';
import {
  CONNECT_STATUS_WAITTING,
  CONNECT_STATUS_SUCCESS,
  CONNECT_STATUS_FAIL,
  CONNECT_STATUS_LOST,
  createClient,
  createConnectOptions,
  onConnect
} from 'src/common/mqtt/mqtt';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    foodsInCart: [],
    orderNote: '',
    arriveTime: 0,    // 配送详情-送达时间
    personNum: 0,    // 配送详情-人数
    cartBranchId: 0,  // 当前购物车数据对应的门店id，进入菜例列表时设置
    popStateListener: [],   // 用于监听全屏子组件popState, 判断当前路由是直接返回还是隐藏子组件 {stateName: , callBackFunction:}
    requiredFoods: [],  // 必选菜品
    requiredGroupFoods: [],  // 必选菜品
    paidOrderIdWithin2Hours: '',  // 2小时内用户成功支付的订单编号，如果有则必选菜不强制添加
    suitSelectedFoods: {},  // 可选套餐点选的菜品（加入购物车前）
    currentSuitDiffPriceMapByGroupId: {},   // 当前套餐加价信息：{groupId1: 2, groupId2: 5}
    oneColDisplay: null,  // 商品列表显示单列模式
    clickEventOn: false,   // 是否正在发生点击事件，用于防止重复点击事件（如嵌套的BScroll）
    businessSetting: {},
    preOrderDetail: {},
    mqConnectStatus: CONNECT_STATUS_WAITTING,  // mq链接状态
    mqMessagePayLoad: null, // mq消息内容
    mqRequestId: '',   // mq requestId
    selectedCard: {},   // 选中的卡券
    pointsChecked: [], // 使用积分复选框
    wxJsApiConfigStatus: null, // 微信JS-SDK是否已注入权限验证配置 true成功 false失败
    forAnotherPay: false, // 是否是为朋友代付（微信分享打开）
    takeCardsModalVisible: false, // 领取卡券modal显示状态
    takeCardsArr: [], // 要领取的卡券
    takeCardsSearch: false,
    takeCardsBranchIds: [], // 处理过领券下单业务的门店，用于外卖/秒吃/自提多门店应用切换门店
    welcomeImgVisible: false // 应用启动欢迎图片显示状态
  },
  // state 数据持久化防止刷新失效
  plugins: [
    createPersistedState({
      paths: [
        'foodsInCart',
        'orderNote',
        'arriveTime',
        'personNum',
        'cartBranchId',
        'requiredFoods',
        'paidOrderIdWithin2Hours',
        'businessSetting',
        'mqConnectStatus',
        'mqMessagePayLoad',
        'mqRequestId',
        'selectedCard',
        'takeCardsModalVisible',
        'takeCardsArr',
        'takeCardsSearch',
        'takeCardsBranchIds',
        'welcomeImgVisible'
      ],
      storage: window.sessionStorage
    })
  ],
  getters: {
    // 计算购物车中菜品总数量和总金额
    cartFoodsTotal: function (state, getters) {
      let foods = state.foodsInCart.length > 0 ? state.foodsInCart : (state.preOrderDetail.foodList || []),
        count = 0,
        amount = 0;
      for (let food of foods) {
        count += (food.count || food.qty);
        let price = getters.getCartFoodTotalPrice(food);
        amount += price;
      }
      return {count, amount};
    },
    cartFoodsTotalPriceOriginal: function (state, getters) {
      let foods = state.foodsInCart.length > 0 ? state.foodsInCart : (state.preOrderDetail.foodList || []),
        amount = 0;
      for (let food of foods) {
        let price = getters.getCartFoodTotalPriceOriginal(food);
        amount += price;
      }
      return amount;
    },
    // 第二份半价优惠活动
    cartFoodsHalfTotal: function (state, getters) {
      let foods = state.foodsInCart.length > 0 ? state.foodsInCart : (state.preOrderDetail.foodList || []),
        halfAmount = 0;
      let halfFoods = foods.filter(food => food.halfPrice !== -1);
      let noHalfFoods = foods.filter(food => food.halfPrice === -1);
      if (halfFoods.length > 0) {
         if (halfFoods[0].halfDistype === 'LOW') {
            halfFoods.sort(function (a, b) {
              return a.price - b.price;
            });
         } else {
            halfFoods.sort(function(a, b) {
              return b.price - a.price;
            });
         }
         console.log(halfFoods);
         let sumQty = 0;
         halfFoods.forEach(function(item) {
             sumQty += item.count || item.qty;
           });
         let halfBaseQty = halfFoods[0].halfBaseQty;
         let halfDisQty = halfFoods[0].halfDisQty;
         let needHalfDisQty = 0;
         if (halfBaseQty > 0) {
            needHalfDisQty = Math.floor(sumQty / halfBaseQty * halfDisQty);
         }
         for (let food of halfFoods) {
            if (needHalfDisQty > 0) {
              let qty = food.count || food.qty;
              if (needHalfDisQty >= qty) {
                halfAmount += food.halfPrice * qty;
                needHalfDisQty -= qty;
              } else {
                halfAmount += food.halfPrice * needHalfDisQty + food.price * (qty - needHalfDisQty);
                needHalfDisQty = 0;
              }
            } else {
              let price = getters.getCartFoodTotalPriceOriginal(food);
              halfAmount += price;
            }
         }
      }
      if (noHalfFoods.length > 0) {
        for (let food of noHalfFoods) {
          let price = getters.getCartFoodTotalPriceOriginal(food);
          halfAmount += price;
        }
      }
      return halfAmount;
    },
    // 验证必选菜是否在购物车中
    checkRequiredFoodsInCart: function (state) {
      if (state.paidOrderIdWithin2Hours !== '' || getUserIdentity('businessType') !== BUSINESS_TYPE_TS) {
        return {validate: true};
      }
      let branchDish = state.mqMessagePayLoad && state.mqMessagePayLoad.dish ? state.mqMessagePayLoad.dish : [],
        orderFoods = state.foodsInCart.concat(branchDish);
      for (let food of state.requiredFoods) {
        let foodCountLimit = food.countLimit === state.appConst.FOOD_REQUIRED_PERPEOPLE ? state.personNum : 1,
          orderFoodCount = 0;
        for (let orderFood of orderFoods) {
          if (orderFood.id && orderFood.id === food.id) {  // 购物车点菜
            orderFoodCount += orderFood.count;
          } else if (orderFood.goodsName === food.name) {  // 门店点菜
            orderFoodCount += orderFood.num;
          }
        }
        if (orderFoodCount < foodCountLimit) {
          let msg = foodCountLimit > 1 ? '请按人数点餐' : '请至少点一份';
          return {validate: false, message: '点菜信息错误：必选菜品（' + food.name + '）' + msg}
        }
      }
      let groupFoodRequiredName = '';
      let groupFoodRequiredUnChecked = state.requiredGroupFoods.length > 0;
      for (let groupFood of state.requiredGroupFoods) {
        groupFoodRequiredName = groupFood.name;
        for (let orderFood of orderFoods) {
          if (orderFood.id && orderFood.id === groupFood.id) {  // 购物车点菜
            groupFoodRequiredUnChecked = false;
            break;
          } else if (orderFood.goodsName === groupFood.name) {  // 门店点菜
            groupFoodRequiredUnChecked = false;
            break;
          }
        }
      }
      if (groupFoodRequiredUnChecked) {
        return {validate: false, message: '【' + groupFoodRequiredName + '】是必选的哦'}
      }
      return {validate: true};
    },
    /**
     * 按索引查询购物车中的某个菜
     * @param state
     */
    getCartFoodByIndex: (state) => (index) => {
      return state['foodsInCart'][index];
    },
    ifHaveSpecOrSettings: (state) => (food) => {
      let settingList = food.settingInfoList;
      if (settingList && settingList.length > 0) {
        return true;
      }
      let specList = food.specInfoList;
      if (specList && specList.length > 1) {
        return true;
      }
      return false;
    },
    /**
     * 计算某菜品是否有必选要求
     * @param state
     */
    ifHaveMustSetting: (state) => (food) => {
      let settingList = food.settingInfoList;
      if (!settingList || settingList.length === 0) {
        return false;
      }
      let index = settingList.findIndex((setting) => {
        if (setting.canMust !== state.appConst.FOOD_SETTING_MUST_YES) {
          return false;
        }
        if (!setting.settingOptList || setting.settingOptList.length === 0) {
          return false;
        }
        return true;
      });

      if (index === -1) {
        return false;
      }
      return true;
    },
    /**
     * 计算某个菜品（id一致）在购物车中的数量
     * 例如，同一个套餐（不同点选或要求）在购物车中的数量、同一个菜（不同的要求）在购物车中的数量
     * @param state
     */
    foodCountInCart: (state) => (foodId) => {
      let foodsInCart = state.foodsInCart;
      if (foodsInCart.length === 0) {
        return 0;
      }
      let count = 0;
      foodId = foodId - 0;
      for (let food of foodsInCart) {
        if ((food.id - 0) === foodId) {
          count += food.count;
        }
      }
      return count;
    },
    /**
     * 当前正在点选的套餐的总差价
     * @param state
     * @return {number}
     */
    currentSuitDiffPrice: (state) => {
      let diffPrices = Object.values(state.currentSuitDiffPriceMapByGroupId),
        totalDiffPrice = 0;
      if (diffPrices.length === 0) {
        return 0;
      }
      for (let diffPrice of diffPrices) {
        totalDiffPrice += diffPrice - 0;
      }
      return totalDiffPrice;
    },
    /**
     * 计算购物车中某个套餐菜的差价
     * @param state
     */
    cartSuitDiffPrice: (state) => (suit) => {
      let groups = suit.foodSuitGroups || suit.suitGroups || [],
        totalDiffPrice = 0;
      for (let group of groups) {
        let cartDetails = group.cartDetails || group.details;
        for (let detail of cartDetails) {
          totalDiffPrice += (detail.diffprice || detail.diffPrice || 0) * (detail.userCount || 1) - 0;
        }
      }
      return totalDiffPrice;
    },
    /**
     * 某个菜例在购物车中的总价格     会员价
     * @param state
     * @param getters
     */
    getCartFoodTotalPrice: (state, getters) => (food) => {
      let price = food.costPrice === -1 ? food.price : food.costPrice;
      if (food.foodType === state.appConst.FOOD_TYPE_SET_MEAL) {
        let diffPrice = getters.cartSuitDiffPrice(food);
        price += diffPrice - 0;
      }
      return price * (food.count || food.qty);
    },
    /**
     * 某个菜例在购物车中的总的原始价格（用于设置了不显示会员价的商户的页面显示）
     * @param state
     * @param getters
     */
    getCartFoodTotalPriceOriginal: (state, getters) => (food) => {
      let price = food.price;
      if (food.foodType === state.appConst.FOOD_TYPE_SET_MEAL) {
        let diffPrice = getters.cartSuitDiffPrice(food);
        price += diffPrice - 0;
      }
      return price * (food.count || food.qty);
    },
    /**
     * 用于显示的订单整单备注
     * @param state
     * @return {*}
     */
    orderNoteShown: (state) => {
      let note = state.orderNote;
      if (note && note.indexOf('打包带走')) {
        return note.replace('打包带走', '');
      }
      return note;
    }
  },
  mutations: {
    setOrderNote: function (state, allNote) {
      state.orderNote = allNote;
    },
    // 将商品加入购物车
    addFoodsToCart: function (state, food) {
      // 加入购物车
      if (food.foodType === state.appConst.FOOD_TYPE_SET_MEAL && (!food.foodSuitGroups || food.foodSuitGroups.length === 0)) {
        return false;
      }
      let temp = state.foodsInCart.findIndex((item) => { // 查找匹配的商品
        if (item.id !== food.id || item.specId !== food.specId || item.optionList !== food.optionList || food.foodType !== item.foodType) {
          return false;
        }
        if (food.foodType !== state.appConst.FOOD_TYPE_SET_MEAL) {
          return true;
        }
        if (food.foodSuitGroups.length !== item.foodSuitGroups.length) {
          return false;
        }
        // 以id-specId为键的所有详情菜
        let foodDetailsMapById = state.appUtils.getSuitCartDetailsMapById(food);
        let itemDetailsMapById = state.appUtils.getSuitCartDetailsMapById(item);
        let foodDetailsIdArr = Object.keys(foodDetailsMapById),
          itemDetailsIdArr = Object.keys(itemDetailsMapById);
        if (foodDetailsIdArr.length !== itemDetailsIdArr.length) {
          return false;
        }
        for (let detailId of foodDetailsIdArr) {
          let foodDetail = foodDetailsMapById[detailId],
            itemDetail = itemDetailsMapById[detailId];
          if (!itemDetail) {
            return false;
          }
          if (itemDetail.optionList !== foodDetail.optionList || itemDetail.userCount !== foodDetail.userCount) {
            return false;
          }
        }
        return true;
      });
      if (temp === -1) {
        let initCount = 1;
        if (food.addCount) {
          initCount = food.addCount;
        } else if (food.multiple === state.appConst.FOOD_MULTIPLE_YES && food.mincount > 0) {
          initCount = food.mincount;
        } else if (
            getUserIdentity('businessType') === BUSINESS_TYPE_TS &&
            state.paidOrderIdWithin2Hours === '' &&
            food.required === state.appConst.FOOD_REQUIRED_YES &&
            food.countLimit === state.appConst.FOOD_REQUIRED_PERPEOPLE
        ) {
          let branchDish = state.mqMessagePayLoad && state.mqMessagePayLoad.dish ? state.mqMessagePayLoad.dish : [],
            branchFoodCount = 0;             // 门店点菜
          for (let branchFood of branchDish) {
            if (branchFood.goodsName === food.name) {
              branchFoodCount += branchFood.num - 0;
            }
          }
          initCount = branchFoodCount < state.personNum ? (state.personNum - branchFoodCount) : 1;
        }
        if (Number.isInteger(initCount) === false) {
          initCount = initCount.toFixed(2) - 0;
        }
        Vue.set(food, 'count', initCount); // 该食品是否有count属性，没有就添加并初始化为1;
        if (!food.optionList) {
          Vue.set(food, 'optionList', '');
        }
        state.foodsInCart.push(food);
      } else {
        let cartFood = state.foodsInCart[temp];
        if (cartFood.count >= food.qty) {   // 估清
          return false;
        }
        let addCount = food.addCount ? food.addCount : 1,
          targetCount = cartFood.count + addCount;

        if (Number.isInteger(targetCount) === false) {
          targetCount = targetCount.toFixed(2) - 0;
        }
        cartFood.count = targetCount;
        Vue.set(state.foodsInCart, temp, cartFood);
      }
      Vue.delete(food, 'addCount');
      setLocalStorageItem(`cartInfo${state.cartBranchId}`, {
        foodsInCart: state.foodsInCart,
        personNum: state.personNum,
        businessType: getUserIdentity('businessType')
      }, 1 * 60 * 60 * 1000);
    },
    // 从购物车中移除商品
    removeFoodsFromCart: function (state, food) {
      let temp = state.foodsInCart.findIndex((item) => { // 查找匹配的商品
        return item.name === food.name && item.id === food.id && item.specId === food.specId && item.optionList === food.optionList;
      });

      if (temp !== -1) {
        let currentFood = state.foodsInCart[temp],
          reduceCount = food.reduceCount ? food.reduceCount : 1,  // 要移除的数量
          targetCount = Math.max(currentFood.count - reduceCount, 0);
        if (Number.isInteger(targetCount) === false) {
          targetCount = targetCount.toFixed(2) - 0;
        }
        if (currentFood.count > 0) {
          // 默认选多份的商品，起售数量移除时，数量变为0
          if (food.multiple === state.appConst.FOOD_MULTIPLE_YES && targetCount < food.mincount) {
            currentFood.count = 0;
          } else if (
              getUserIdentity('businessType') === BUSINESS_TYPE_TS &&
              state.paidOrderIdWithin2Hours === '' &&
              food.required === state.appConst.FOOD_REQUIRED_YES
          ) {   // 必选菜品
            let branchDish = state.mqMessagePayLoad && state.mqMessagePayLoad.dish ? state.mqMessagePayLoad.dish : [],
              branchFoodCount = 0;             // 门店点菜
            for (let branchFood of branchDish) {
              if (branchFood.goodsName === food.name) {
                branchFoodCount += branchFood.num - 0;
              }
            }
            let minCount = food.countLimit === state.appConst.FOOD_REQUIRED_PERPEOPLE ? state.personNum : 1;
            minCount = Math.max(minCount - branchFoodCount, 0);
            if (targetCount >= minCount) {
              currentFood.count = targetCount;
            }
          } else {
            currentFood.count = targetCount;
          }
          if (currentFood.count === 0) {
            state.foodsInCart.splice(temp, 1);
          } else {
            Vue.set(state.foodsInCart, temp, currentFood);
          }
        } else {
          state.foodsInCart.splice(temp, 1);
        }
        Vue.delete(food, 'reduceCount');
        setLocalStorageItem(`cartInfo${state.cartBranchId}`, {
          foodsInCart: state.foodsInCart,
          personNum: state.personNum,
          businessType: getUserIdentity('businessType')
        }, 1 * 60 * 60 * 1000);
      }
    },
    // 静默清空购物车，不询问
    setCartEmptySilent: function (state, force = false) {
      let requiredFoods = [],
        foodsInCart = state.foodsInCart;
      for (let food of foodsInCart) {
        if (
            force === false &&
            getUserIdentity('businessType') === BUSINESS_TYPE_TS &&
            state.paidOrderIdWithin2Hours === '' &&
            food.required === state.appConst.FOOD_REQUIRED_YES
        ) {
          requiredFoods.push(food);
        } else {
          Vue.set(food, 'count', 0);
        }
      }
      state.foodsInCart = requiredFoods;
      window.localStorage.removeItem(`cartInfo${state.cartBranchId}`);
    },
    // 设置到店时间
    setArriveTime: function (state, arriveTime) {
      state.arriveTime = arriveTime;
    },
    // 设置到店人数
    setPersonNum: function (state, personNum) {
      state.personNum = personNum;
    },
    // 设置购物车门店id
    setCartBranchId: function (state, branchId) {
      state.cartBranchId = branchId;
    },
    /**
     * 设置popstate监听信息, 用于弹出全屏子组件时
     * @param {Object} listenerInfo {stateName: 'food-detail', callBackFunction: function () {}}
    */
    addPopStateListener (state, listenerInfo) {
      let stateName = listenerInfo.stateName;
      window.history.pushState({name: stateName}, '', '');
      state.popStateListener.push(listenerInfo);
    },
    // 移除popstate监听信息, 用于隐藏全屏子组件时
    deletePopStateListener (state) {
      let popListener = state.popStateListener.pop();
      popListener['callBackFunction']();
      // history.go(-1);
    },
    // 接受门店消息后存储消息内容
    // setBranchMessagePayLoad (state, payLoad) {
    //   state.branchMessagePayLoad = payLoad;
    // },
    // mq接受消息后存储mq消息内容
    setMqMessagePayLoad (state, payLoad) {
      state.mqMessagePayLoad = payLoad;
    },
    // 设置mq链接状态，初始状态为'waitting'等待链接
    setMqConnectStatus (state, status) {
      state.mqConnectStatus = status;
    },
    // 设置mq requestId
    setMqRequestId (state, requestId) {
      state.mqRequestId = requestId;
    },
    // 设置必选菜品
    setRequiredFoods (state, requiredFoods) {
      state.requiredFoods = requiredFoods;
    },
    // 设置必选菜品
    setRequiredGroupFoods (state, requiredGroupFoods) {
      state.requiredGroupFoods = requiredGroupFoods;
    },
    setPaidOrderIdWithin2Hours (state, orderId) {
      state.paidOrderIdWithin2Hours = orderId;
    },
    /**
     * 初始化可选套餐已选菜品信息
     * @param {Object} suitInfo 套餐菜基本信息
     */
    suitSelectedFoodsInit(state, suitInfo) {
      suitInfo.foodSuitGroups = {};
      state.suitSelectedFoods = suitInfo;
    },
    /**
     * 可选套餐设置分组点选信息
     * @param state
     * @param group
     */
    suitSelectedFoodsSetGroup (state, group) {
      Vue.set(state.suitSelectedFoods.foodSuitGroups, group.id, group);
    },
    /**
     * 设置某套餐的某分组的加价信息
     * @param state
     * @param groupDiffPrice 分组加价信息：{groupId: 1, diifPrice: 5}
     */
    currentSuitDiffPriceSetGroup (state, groupDiffPrice) {
      Vue.set(state.currentSuitDiffPriceMapByGroupId, groupDiffPrice.groupId, groupDiffPrice.diffPrice);
    },
    /**
     * 重置当前套餐的差价信息，用于套餐开始点选之前的初始化
     * @param state
     */
    currentSuitDiffPriceReset (state) {
      state.currentSuitDiffPriceMapByGroupId = {};
    },
    /**
     * 设置商品列表展示模式
     * @param state
     * @param oneColDisplay
     */
    oneColDisplaySet (state, oneColDisplay) {
      state.oneColDisplay = oneColDisplay;
    },
    /**
     * 开始点击事件
     * @param state
     */
    clickEventOnStart (state) {
      state.clickEventOn = true;
      setTimeout(() => {
        state.clickEventOn = false;
      }, 200);
    },
    setBusinessSetting (state, setting) {
      state.businessSetting = setting;
    },
    /**
     * 管理预订单详情，用于加菜
     * @param state
     * @param order
     */
    setPreOrderDetail (state, order) {
      state.preOrderDetail = order;
    },
    /**
     * 选择卡券
     * @param state
     * @param {Object} card 卡券
     */
    selectCard (state, card) {
      state.selectedCard = card;
    },
    /**
     * 选择使用积分
     * @param state
     * @param {Array} checkedArr
     */
    pointsCheck (state, checkedArr) {
      state.pointsChecked = checkedArr;
    },
    /**
     * 微信JS-SDK权限验证配置状态
     * @param state
     * @param status
     */
    setWxJsApiConfigStatus (state, status) {
      state.wxJsApiConfigStatus = status;
    },
    /**
     * 是否是为朋友代付
     * @param state
     * @param isForAnotherPay
     */
    setForAnotherPay (state, isForAnotherPay) {
      state.forAnotherPay = isForAnotherPay;
    },
    /**
     * 切换领券modal的可见状态
     * @param state
     */
    setTakeCardsModalVisible(state, visible) {
      state.takeCardsModalVisible = visible;
    },
    /**
     * 领券活动的卡券
     * @param state
     * @param cards
     */
    setTakeCardsArr(state, cards) {
      state.takeCardsArr = cards;
    },
    /**
     * 添加处理过领券下单的门店
     * @param state
     * @param branchId
     */
    addTakeCardsBranchIds (state, branchId) {
      state.takeCardsBranchIds.push(branchId);
    },
    setTakeCardsSearch (state, search) {
      state.takeCardsSearch = search;
    },
    /**
     * 变更欢迎页的显示状态
     * @param state
     * @param visible
     */
    setWelcomeImgVisible (state, visible) {
      state.welcomeImgVisible = visible;
    }
  },
  actions: {
    // 多个菜品批量加入购物车（再来一单）
    addOrderFoodsToCart ({commit}, foods) {
      if (foods.length > 0) {
        for (let orderFood of foods) {
          commit('addFoodsToCart', orderFood);
        }
      }
    },
    // 更改购物车门店
    changeCartBranchId ({commit, state, dispatch}, branchId) {
      if (state.cartBranchId !== branchId) {
        let localStorageCartInfo = getLocalStorageItem(`cartInfo${branchId}`);
        commit('setCartBranchId', branchId);
        commit('setCartEmptySilent', true);
        // 检查localStorage中是否有购物车数据，若匹配的购物车数据则交由vuex管理
        if (localStorageCartInfo &&
          localStorageCartInfo.businessType === getUserIdentity('businessType')
        ) {
          commit('setPersonNum', localStorageCartInfo.personNum);
          dispatch('addOrderFoodsToCart', localStorageCartInfo.foodsInCart);
        }
      }
    },
    // 设置就餐人数并检查必选菜品
    changePersonNum ({commit, state}, personNum) {
      commit('setPersonNum', personNum);
      if (state.paidOrderIdWithin2Hours !== '' || getUserIdentity('businessType') !== BUSINESS_TYPE_TS) {
        return;
      }
      for (let food of state.requiredFoods) {
        let foodCountLimit = food.countLimit === state.appConst.FOOD_REQUIRED_PERPEOPLE ? personNum : 1,
          branchDish = state.mqMessagePayLoad && state.mqMessagePayLoad.dish ? state.mqMessagePayLoad.dish : [],
          orderFoods = state.foodsInCart.concat(branchDish),
          orderFoodCount = 0;
        for (let orderFood of orderFoods) {
          if (orderFood.id && orderFood.id === food.id) {  // 购物车点菜
            orderFoodCount += orderFood.count;
          } else if (orderFood.goodsName === food.name) {  // 门店点菜
            orderFoodCount += orderFood.num;
          }
        }
        if (orderFoodCount < foodCountLimit) {
          Vue.set(food, 'addCount', foodCountLimit - orderFoodCount);
          commit('addFoodsToCart', food);
        }
      }
    },
    // 清空购物车，切记这是个异步操作，应用actions而不是mutations
    setCartEmpty: function ({commit}) {
      MessageBox.confirm('清空购物车?', '提示').then(action => {
        commit('setCartEmptySilent');
      });
    },
    // 拉取门店点餐信息
    // pullBranchMsg ({commit}) {
    //   return new Promise((resolve, reject) => {
    //     mnsBranchTableMsg().then(data => {
    //       let res = JSON.parse(data);
    //       commit('setBranchMessagePayLoad', res);
    //       resolve(res);
    //     }).catch(err => {
    //       reject(err);
    //     });
    //   });
    // },
    /**
     * 链接mq消息通道
     */
    mqConnect ({commit, state}, force = false) {
      if (state.mqConnectStatus === CONNECT_STATUS_SUCCESS && force === false) {
        return;
      }
      if (state.mqConnectStatus === CONNECT_STATUS_SUCCESS) {
        commit('setMqConnectStatus', CONNECT_STATUS_WAITTING);
      }
      let mqClient = createClient(),
        connectOptions = createConnectOptions();
      // 收到通知
      mqClient.onMessageArrived = function (message) {
        console.log('收到mqtt消息', message);
        let payload = message.payloadString,
          payloadObj = JSON.parse(payload);
        commit('setMqMessagePayLoad', payloadObj);
      };
      // 断开链接
      mqClient.onConnectionLost = function (response) {
        console.error('mqtt断开链接');
        commit('setMqConnectStatus', CONNECT_STATUS_LOST);
      }

      let clientId = mqClient.clientId,
        requestIdIndex = mqClient.clientId.indexOf('@@@') + 3,
        requestId = clientId.substring(requestIdIndex);
      commit('setMqRequestId', requestId);
      // 链接成功
      connectOptions.onSuccess = function () {
        console.log('mqtt链接成功');
        onConnect(mqClient);
        commit('setMqConnectStatus', CONNECT_STATUS_SUCCESS);
      };
      // 链接失败
      connectOptions.onFailure = function () {
        console.error('mqtt链接失败');
        commit('setMqConnectStatus', CONNECT_STATUS_FAIL);
      }
      // 建立链接
      mqClient.connect(connectOptions);
    }
  },
  modules: {
    appConst,
    appUtils
  }
});



// WEBPACK FOOTER //
// ./src/config/store.config.js